import FAQ from "@/components/TopTen/FAQ";
import AirBannerContent from "@/components/TopTen/AirBannerContent";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  BannerDishWasherDescription,
  InfoDishwashers,
  TopTenDishWasherFAQ,
  TopTenSeo,
} from "@/constants/TopTen";
import { getProductsBySkuV2 } from "@/services/elasticsearch/getProducts";
import { useTranslation } from "next-i18next";
import SEO from "@/components/seo";
import { handshakeCookieName } from "@/constants";
import { localeHandShake } from "@/services/token/handshake";
import { buildCanonicalUrl } from "@/utils/canonical";

import DashWasherBannerInfo from "@/components/TopTen/DashWasherBannerInfo";
const Index = ({ products: myProducts }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  const products = myProducts.map((info) => (info === null ? [] : info?.data));
  return (
    <>
      <SEO
        title={TopTenSeo.dish_washer[`title_${language}`]}
        description={TopTenSeo.dish_washer[`description_${language}`]}
      >
        <link
          rel="canonical"
          href={buildCanonicalUrl("/top-ten/dish-washer", language)}
        />
      </SEO>

      <section className="w-[80%] max-[768px]:w-[98%] mx-auto my-4 max-[768px]:my-1">
        <AirBannerContent
          title={
            language === "en"
              ? `Top Dishwashers in Saudi Arabia`
              : "قائمة أبرز غسالات الصحون في المملكة العربية السعودية"
          }
          content={BannerDishWasherDescription[language]}
        />
        {InfoDishwashers.map((info, key) => (
          <DashWasherBannerInfo
            t={t}
            key={key}
            data={info}
            language={language}
            products={products[key]}
          />
        ))}
        {/* This Code is not in thier contents */}
        {/* <AirFooterBannerInfo /> */}
        <FAQ
          title={
            language === "en"
              ? "Frequently Asked Questions About Dishwashers"
              : "الأسئلة الشائعة حول غسالات الصحون"
          }
          language={language}
          data={TopTenDishWasherFAQ}
        />
      </section>
    </>
  );
};

export default Index;

export async function getServerSideProps({ locale, req, res }) {
  const handshake =
    req.cookies[handshakeCookieName(locale)] ||
    (await localeHandShake(locale, { req, res }))?.data?.token;
  const products = await Promise.all([
    null,
    null,
    getProductsBySkuV2(
      [
        "120500101814004",
        "120500101812012",
        "120503001814008",
        "120500201814001",
      ],
      handshake
    ),
    getProductsBySkuV2(
      ["120501801812003", "120500201814001", "120500101812012"],
      handshake
    ),
    getProductsBySkuV2(
      ["120500101812012", "120500101812011", "120501801812003"],
      handshake
    ),
    getProductsBySkuV2(
      ["120500701814023", "120500701814031", "120500701814032"],
      handshake
    ),
    getProductsBySkuV2(
      [
        "120500101814004",
        "120500101814003",
        "120500101812012",
        "120500101812011",
      ],
      handshake
    ),
  ]);
  return {
    props: {
      products,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
